import { BaseContainer } from './BaseContainer';
import { TicketIcon } from 'foundations-assets/icons/components/TicketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const TicketSvg = () => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: '60%',
    children: /*#__PURE__*/_jsx(TicketIcon, {})
  });
};